import { getApplyToAll, getGeneralTimeslotConfigurations, getIntervalConfigurations } from '@modules/timetable';
import {
  GetTimeSlotConfigurationDefaultValuesArgs,
  GetTimeSlotConfigurationDefaultValuesResult,
  TimeSlotConfigurationsDataType,
} from '../types/manageTimetable';
import { initialTimeSlotConfigurationValues } from '../constants';

export const getTimeSlotConfigurationDefaultValues = ({
  timeSlotConfigurations,
  timelineItems,
  week,
  batchClassIds,
}: GetTimeSlotConfigurationDefaultValuesArgs): GetTimeSlotConfigurationDefaultValuesResult => {
  let timeSlotConfigurationDefaultValues: TimeSlotConfigurationsDataType = {
    ...initialTimeSlotConfigurationValues,
  };

  if (timeSlotConfigurations) {
    timeSlotConfigurationDefaultValues = getGeneralTimeslotConfigurations(timeSlotConfigurations);
  }

  if (timelineItems.length > 0) {
    timeSlotConfigurationDefaultValues = getIntervalConfigurations({
      timelineItems,
      week,
      batchClassIds,
      timeSlotConfigurationDefaultValues,
    });
  }

  const applyToAll: boolean = getApplyToAll(timeSlotConfigurationDefaultValues);

  // If apply to all, send only the monday's configurations
  if (applyToAll) {
    timeSlotConfigurationDefaultValues = {
      ...initialTimeSlotConfigurationValues,
      monday: timeSlotConfigurationDefaultValues.monday,
    };
  }

  return {
    timeSlotConfigurationDefaultValues,
    applyToAll,
  };
};
